export const initialInbndListOptions = {
  tearoff: false,
  lines: 15,
  background: true,
  bright: 80,
  font: 2,
  border: true,
};
